<ng-container [ngSwitch]="hintTemplate">
  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.OFFERS_TABLE"
    class="d-flex"
    subTitle="Offers"
    i18n-subTitle="@@common.offers"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@offer.table_offer_hint">
      Offer is a tool that brings together all business and technical details on how affiliates should conduct marketing campaigns. On this
      page, you can view all offers that have ever been created, edit them and create new ones.
    </div>
    <div class="mb-15" i18n="@@offer.table_offer_hint_plus_btn">The Plus button — open the Offer Wizard and create a new offer.</div>
    <div class="mb-15" i18n="@@offer.table_offer_hint_data_exporter">
      Data Exporter — jump to a thorough statistics report regarding offers.
    </div>
    <div class="mb-15" i18n="@@offer.table_offer_hint_description_preset">
      Description Presets — open a list of ready-made descriptions you can add to any offer.
    </div>
    <div class="mb-15" i18n="@@offer.table_offer_hint_url_replacer">URL Replacer — change a URL within all matching offers.</div>
    <div class="mb-15" i18n="@@offer.table_offer_hint_eq_btn">
      The Equalizer button — apply filters to find specific offers in the table.
    </div>
    <div class="mb-15" i18n="@@offer.table_offer_hint_gear_btn">
      The Gear button — add and remove columns from the table and change their order.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.OFFERS_PAGE"
    class="d-flex"
    subTitle="Offer Page"
    i18n-subTitle="@@offer.page"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@offer.page_hint">There are multiple widgets for an offer.</div>
    <div class="mb-15" i18n="@@offer.page_hint_basic_info">
      Basic Information widget allows you to see overall information about the offer, check statistics of effective work of the offer, etc.
      Here you should set up goals for the offer and amount of payout per action.
    </div>
    <div class="mb-15" i18n="@@offer.page_hint_urls">
      The URL’s widget allows you to add offer URLs. Here you should place the preview URL and tracking URL from the funnel’s page (LD).
    </div>
    <div class="mb-15" i18n="@@offer.page_hint_rules">
      The Rules widget allows you to set up additional params as Targets, Affiliate Tracking Domains, Affiliates Access, etc.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.GOALS_TABLE"
    class="d-flex"
    subTitle="Offer Goals"
    i18n-subTitle="@@settings.offer_goals"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@offer.goal_table_hint">
      Offer Goal describes what kind of target action counts as a conversion in each specific offer. It can be used to attach various
      payment rules and to get precise data reports on each offer.
    </div>
    <div class="mb-15" i18n="@@offer.goal_table_hint_1">
      Click the ID of an offer to view the list of its conversions and configure affiliate access rights.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.TARGETS_TABLE"
    class="d-flex"
    subTitle="Targeting"
    i18n-subTitle="@@offer.targeting"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@offer.targets_table_hint">Here you have the opportunity to block access to an offer by GEO.</div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.CLICKS_TABLE"
    class="d-flex"
    subTitle="Clicks"
    i18n-subTitle="@@common.clicks"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@clicks.table_hint">
      A click occurs when a lead visits an offer URL that is promoted by an affiliate. A click holds information about the lead and
      describes in numerous fields how and when he visited the link.
    </div>
    <div class="mb-15" i18n="@@clicks.table_hint_1">
      Click ID refers to the click page that keeps all information about it, including the list of conversions. In addition, it allows you
      to manually create a conversion for this click and customize its data, for example, date, payout, revenue, and others.
    </div>
    <div class="mb-15" i18n="@@clicks.table_hint_data_exporter">Data Exporter — open a thorough statistics report on clicks.</div>
    <div class="mb-15" i18n="@@clicks.table_hint_eq_btn">
      The Equalizer button — apply filters to find specific advertisers in the table.
    </div>
    <div class="mb-15" i18n="@@clicks.table_hint_gear_btn">
      The Gear button — add and remove columns from the table and change their order.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.AFFILIATES_TABLE"
    class="d-flex"
    subTitle="Affiliates"
    i18n-subTitle="@@common.affiliates"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@affiliates.table_hint">
      Look through all the affiliates that have ever been created on this CRM. Click the affiliate’s ID to open his page, check the
      information and edit his individual rules if needed. To view sensitive information, pass 2FA.
    </div>
    <div class="mb-15" i18n="@@affiliates.table_hint_plus_btn">
      The Plus button — create an affiliate account in the CRM, then send credentials to the affiliate so he can access the Affiliate Area
      and start promoting your offers.
    </div>
    <div class="mb-15" i18n="@@affiliates.table_hint_data_exporter">Data Exporter — open a thorough statistics report on affiliates.</div>
    <div class="mb-15" i18n="@@affiliates.table_hint_eq_btn">
      The Equalizer button — apply filters to find specific affiliates in the table.
    </div>
    <div class="mb-15" i18n="@@affiliates.table_hint_gear_btn">
      The Gear button — add and remove columns from the table and change their order.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.AFFILIATES_TRACKERS_TABLE"
    class="d-flex"
    subTitle="Affiliates Trackers"
    i18n-subTitle="@@common.affiliates_trackers"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@affiliates.trackers_table_hint">
      Affiliate Trackers are postbacks to third-party resources. They are sent each time the affiliate lands a conversion. Usually,
      affiliates use them to track their efficiency.
    </div>
    <div class="mb-15" i18n="@@affiliates.trackers_table_hint_1">
      Global Affiliate Trackers are applied to all conversions of the affiliate with a selected Goal type.
    </div>
    <div class="mb-15" i18n="@@affiliates.trackers_table_hint_2">
      Default ones are applied to conversions with a selected Goal and a mentioned Offer.
    </div>
    <div class="mb-15" i18n="@@affiliates.trackers_table_hint_gear_button">
      The Gear button — add and remove columns from the table and change their order.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.ADVERTISERS_TABLE"
    class="d-flex"
    subTitle="Advertisers"
    i18n-subTitle="@@common.advertisers"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@advertiser.table_hint">
      Here is the list of all integrated advertisers. Click the advertiser’s ID to check all information on him and configure settings like
      API Integration, Documents, and Marketing Tools.
    </div>
    <div class="mb-15" i18n="@@advertiser.table_hint_plus_btn">The Plus button — click to create a new advertiser account in the CRM.</div>
    <div class="mb-15" i18n="@@advertiser.table_hint_data_exporter">Data Exporter — open a thorough statistics report on advertisers.</div>
    <div class="mb-15" i18n="@@advertiser.table_hint_eq_btn">
      The Equalizer button — apply filters to find specific advertisers in the table.
    </div>
    <div class="mb-15" i18n="@@advertiser.table_hint_gear_btn">
      The Gear button — add and remove columns from the table and change their order.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.NOTIFICATIONS_TABLE"
    class="d-flex"
    subTitle="Notifications"
    i18n-subTitle="@@common.notifications"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@notifications.table_hint">Notifications show different messages from CRM.</div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.ACCESS_CONTROLS_AFFILIATES"
    class="d-flex"
    subTitle="Access Controls Affiliates"
    i18n-subTitle="@@affiliate.access_controls_affiliates"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@offer.access_control_aff_table_hint">
      Put check marks in boxes to allow all affiliates of the CRM access one or another widget or page.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.ACCESS_CONTROLS_ADVERTISERS"
    class="d-flex"
    subTitle="Access Controls Advertisers"
    i18n-subTitle="@@advertiser.access_controls_advertisers"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@offer.access_contol_adv_table_hint">
      Put check marks in boxes to allow all advertisers to access one or another widget or page.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.CRM_SETTINGS"
    class="d-flex"
    subTitle="CRM Settings"
    i18n-subTitle="@@settings.crm_settings"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@settings.hint">
      CRM Settings allows you to set up all necessary settings for widgets, tables, icons, etc.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.TRACKING_DOMAINS_TABLE"
    class="d-flex"
    subTitle="Tracking Domains"
    i18n-subTitle="@@common.tracking_domains"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@offer.tracking_domain_table_hint">
      Tracking Domain is a link that keeps the advertised page safe and measures ad effectiveness.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.TOKENS_TABLE"
    class="d-flex"
    subTitle="Tokens"
    i18n-subTitle="@@common.tokens"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@settings.tokens_table_hint_1">
      Create an API token to access the CRM’s API via a third-party server. You can get access to both the affiliate and CRM admin roles.
    </div>
    <div class="mb-15" i18n="@@settings.tokens_table_hint_2">
      To retrieve the API token, create an item in the table, click its ID, then click the protected field Value in the Basic Information
      widget. Pass the 2FA to reveal the API key.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.CRM_TERMS"
    class="d-flex"
    subTitle="CRM Metrics"
    i18n-subTitle="@@settings.crm_metrics"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@settings.metrics_hint_1">
      CRM Metrics are custom data points that are used to evaluate general and highly specific events, actions, or results across the CRM.
    </div>
    <div class="mb-15" i18n="@@settings.metrics_hint_2">There are two types of metrics: Base and Network ones:</div>
    <div class="mb-15" i18n="@@settings.metrics_hint_base">
      Base Metrics can keep track only of items from a limited and preconfigured list. The items are usually specifications of clicks,
      conversions, transactions, and more.
    </div>
    <div class="mb-15" i18n="@@settings.metrics_hint_network">
      Network Metrics are derived from calculation of base metrics. For example, a Network metric can be a ratio of two base metrics,
      multiplied by 100.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.REPORTS_BUILDER"
    class="d-flex"
    subTitle="Data Exporter"
    i18n-subTitle="@@common.data_exporter"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@data_exporter.hint">
      Data Exporter allows you to gather all data on various topics and download a CSV file. Use conditions and date filters to remove
      unimportant information.
    </div>
    <div class="mb-15" i18n="@@data_exporter.hint_1">
      Once you’ve configured a report, click View Report to check whether it contains everything you want. If it’s ok, click Download CSV to
      get the full report.
    </div>
    <div class="mb-15" i18n="@@data_exporter.hint_preset">Presets — configure a report template and use it countless times.</div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.DRILLDOWN_REPORTS"
    class="d-flex"
    subTitle="Drilldown Reports"
    i18n-subTitle="@@common.drilldown_reports"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@drilldown.hint">
      Drilldown report offers aggregated data that can be broken down into smaller subsets. To reveal more granular information on a certain
      aspect, add a grouper. Click any item in the table to decompose it by geolocation, period, or other category. You can keep up to 3
      groupers in a single report.
    </div>
    <div class="mb-15" i18n="@@drilldown.hint_1">
      For example, choose three groupers: Affiliate ID, Country, and Goal ID. Thus, you can view data on all affiliates. Then you can check
      how their data depends on the traffic geolocation. And finally, you can reduce that data to various offers.
    </div>
    <div class="mb-15" i18n="@@drilldown.hint_create_preset">
      Create a preset—arrange a report configuration that you can return to any time by selecting it in the preset drop-down list.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.PRESETS_LIST"
    class="d-flex"
    subTitle="Presets List"
    i18n-subTitle="@@common.presets_list"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@settings.presets_description">
      Configure a set of options that you can later access in Data Exporter, Performance Report, Comparing Analytics, and Offer
      Descriptions.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.EVENTS_LOG"
    class="d-flex"
    subTitle="Events Logs"
    i18n-subTitle="@@settings.events_logs"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@settings.logs_table_hint">
      Events Logs display most of the actions processed by the system, such as bugs, errors, notifications, pushed and rejected leads, and
      so on. There are Namespace, Message and Type of logs in the table.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.AFFILIATES_BILLING_TABLE"
    class="d-flex"
    subTitle="Affiliate Invoices"
    i18n-subTitle="@@affiliate.invoices"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@invoices.table_hint">
      Here you can view all invoices created by Affiliates. You must set the action status for all invoices.
    </div>
    <div class="mb-15" i18n="@@invoices.table_hint_pending">
      Pending: This is the first status after invoice creation. Billing is prepared but not completed. In this status, the affiliate can
      edit the account or move it to the rejected status.
    </div>
    <div class="mb-15" i18n="@@invoices.table_hint_waiting">
      Waiting: the invoice has been prepared but not completed. This status is set by the CRM administrator, which means that the invoice is
      in progress and the partner cannot make changes to this status, but he can download or print the invoice in pdf format.
    </div>
    <div class="mb-15" i18n="@@invoices.table_hint_payed">Payed: billing is closed. This status is set by the network admin of crm.</div>
    <div class="mb-15" i18n="@@invoices.table_hint_declined">
      Declined - when selecting this status, you must indicate the reason in the Declined Note field.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.INCIDENTS_TABLE"
    class="d-flex"
    subTitle="Incidents"
    i18n-subTitle="@@common.incidents"
    linkToDocs="https://docs.irev.com/"
  >
    <div class="mb-15" i18n="@@settings.incidents_table_hint">Incidents show different events related to some divergence in CRM.</div>
    <p i18n="@@settings.incidents_table_hint_1">
      Each incident can be resolved by clicking the Resolve button in front of the incident`s rule.
    </p>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.NOTIFICATIONS_SETTINGS"
    class="d-flex"
    subTitle="Notification Settings"
    i18n-subTitle="@@settings.notification_settings"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@settings.notifications_table_hint">Enable notifications for email, Telegram.</div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.NOTIFICATIONS_SETTINGS_SLACK"
    class="d-flex"
    subTitle="Slack Notification Settings"
    i18n-subTitle="@@settings.slack_notifications_settings"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@settings.slack_notifications_table_hint">
      If you want to receive messages to your Slack channels, here you can select a channel and apply notifications types you need.
    </div>
    <div class="mb-15" i18n="@@settings.slack_notifications_table_hin_1t">
      To select another channel, click on <b>Add Channel</b> Button.
    </div>
    <div class="mb-15" i18n="@@settings.slack_notifications_table_hint_2">
      If you want to receive private messages, you can connect bot in <b>Private Notifications</b> section.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.NOTIFICATIONS_SETTINGS_SLACK_EMPTY"
    class="d-flex"
    subTitle="Notification Settings"
    i18n-subTitle="@@settings.notification_settings"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@settings.slack_notifications_empty_table_hint">
      You must click the <b>Connect</b> button in order to connect your Slack workspace.
    </div>
    <div class="mb-15" i18n="@@settings.slack_notifications_empty_table_hint_1">
      After that you will be redirected to Slack permissions page, where you can select your workspace in the top right corner and click
      <b>Allow</b> button.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.DEALS_UPDATER"
    class="d-flex"
    subTitle="Deals Updater"
    i18n-subTitle="@@common.deals_updater"
    linkToDocs="https://docs.irev.com/"
  >
    <p i18n="@@finance.deals_table_hint">
      Deals Updater allows you to update the Revenue and Payout values for already existing conversions.
    </p>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.DEAL_HISTORY"
    class="d-flex"
    subTitle="Deal History"
    i18n-subTitle="@@finance.deal_history"
    linkToDocs="https://docs.irev.com/"
  >
    <p i18n="@@finance.deals_history_table">
      View all changes made by Deals Updater, including updated values, previous values, and details on who and when the update was made.
    </p>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.AFFILIATE_MANAGER"
    class="d-flex"
    subTitle="Affiliate Manager"
    i18n-subTitle="@@settings.affiliate_manager"
    linkToDocs=""
  >
    <p i18n="@@settings.aff_manager_hint">
      An affiliate manager can log in to the Affiliate Area as any of his sub affiliates and perform any actions that don’t require 2FA.
    </p>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.CONVERSIONS"
    class="d-flex"
    subTitle="Conversions"
    i18n-subTitle="@@common.conversions"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@conversion.table_hint">
      A Conversion indicates a lead’s target action. All registered conversions are listed in this table. Click on a conversion’s ID to
      check its details.
    </div>
    <div class="mb-15" i18n="@@conversion.table_hint_data_exporter">Data Exporter — open a thorough statistics report on conversions.</div>
    <div class="mb-15" i18n="@@conversion.table_hint_import">
      Import Conversions — import conversions from other platforms to the CRM from a CSV file.
    </div>
    <div class="mb-15" i18n="@@conversion.table_hint_eq_btn">
      The Equalizer button — apply filters to find specific advertisers in the table.
    </div>
    <div class="mb-15" i18n="@@conversion_table_hint_geat_btn">
      The Gear button — add and remove columns from the table and change their order.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.CRM_DOCUMENTS"
    class="d-flex"
    subTitle="CRM Documents"
    i18n-subTitle="@@common.crm_documents"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@settings.crm_documents_table_hint">
      Affiliates will see this document during their first visit. They have to agree to it to continue working in the Affiliate Area. Each
      Affiliate can agree to one document with the “Terms and Conditions” status and one with the “Privacy Policy” status. All redundant
      documents won’t be shown to the affiliates.
    </div>
    <div class="mb-15" i18n="@@settings.crm_documents_table_hint_1">
      To see what documents the affiliate has agreed on, go to the affiliate’s page, select the Other tab, and scroll down to the Documents
      section.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.ADVERTISER_BRAND"
    class="d-flex"
    subTitle="Advertiser Brands"
    i18n-subTitle="@@adcertiser.brands"
    linkToDocs=""
  >
    <p i18n="@@advertiser.brand_table_hint">Group several advertisers into a single brand.</p>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.AFFILIATES_GROUP_TABLE"
    class="d-flex"
    subTitle="Affiliate Groups"
    i18n-subTitle="@@affiliate.groups"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@affiliate.group_table_hint">
      Create an affiliate group with a distinct master affiliate who can invite new affiliates directly to the group and visit their
      Affiliate Area cabinets.
    </div>
    <div class="mb-15" i18n="@@affiliate.group_table_hint_master_aff">
      Master Affiliate can invite others to his group by using the group link.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.GOAL_TYPES_TABLE"
    class="d-flex"
    subTitle="Goal Types"
    i18n-subTitle="@@common.goal_types"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@offer.goal_type_table_hint">
      Goal types are means to differentiate Offer Goals; they describe what kind of target action counts as a conversion. For example,
      registration, deposit, or phone verification.
    </div>
    <div class="mb-15" i18n="@@offer.goal_type_table_hint_1">
      Create your own goal types to be able to apply specific payment conditions or to get custom stats reports on each goal type.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.PAYOUT_MODELS_TABLE"
    class="d-flex"
    subTitle="Payout Models"
    i18n-subTitle="@@common.playout_models"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@settings.payout_models_table_hint">
      Payout Business Models allow you to configure a payout model once and apply it any time to any offer, affiliate, or a custom
      combination of conditions. The list of Payout Business Models appears in a payout rule.
    </div>
    <div class="mb-15" i18n="@@settings.payout_models_table_hint_1">
      Use placeholders, mathematical operators and numbers to configure a payout formula.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.REVENUE_MODELS_TABLE"
    class="d-flex"
    subTitle="Revenue Models"
    i18n-subTitle="@@common.revenue_models"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@settings.revenue_models_table_hint">
      Revenue Business Models allow you to configure a revenue model once and apply it any time to any offer, affiliate, advertiser or a
      custom combination of conditions. The list of Revenue Business Models appears in a revenue rule.
    </div>
    <div class="mb-15" i18n="@@settings.payout_models_table_hint_1">Revenue — total profit of the advertiser in a single conversion.</div>
    <div class="mb-15" i18n="@@settings.payout_models_table_hint_2">
      Use placeholders, mathematical operators and numbers to configure a payout formula.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.OFFER_TRACKING_LINK"
    class="d-flex"
    subTitle="Offer Tracking Link"
    i18n-subTitle="@@offer.tracking_link"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@offer.tracking_link_hint">
      This functionality generates an Offer Tracking Link. You must select the required affiliate, offer and offer URL, and it also allows
      you to choose 2 additional parameters.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.BRAND_API_SETTINGS"
    class="d-flex"
    subTitle="API Connection Settings"
    i18n-subTitle="@@common.api_connection_settings"
    linkToDocs="https://docs.platform500.com/wiki/partners-managing/brands/"
  >
    <div class="mb-15" i18n="@@settings.brand_api_hint">
      <div class="fw-bold mb-6">Groups</div>
      There are different groups of settings for integration advertisers into the system such as Auth Settings, Pulling Settings, etc.
    </div>
    <div class="mb-15" i18n="@@settings.brand_api_key_hint">
      <div class="fw-bold mb-6">API Key</div>
      An application programming interface key is a unique identifier used for integration of advertisers into the system.
    </div>
    <div class="mb-15" i18n="@@settings.brand_api_value_hint">
      <div class="fw-bold mb-6">Value</div>
      This is all the necessary information for filling out API fields.
    </div>
    <div class="mb-15" i18n="@@settings.brand_api_hint_edit">
      <div class="fw-bold mb-6">Edit API Settings</div>
      Allows you to edit values for each API Key to integrate advertisers into your system.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.EARNINGS"
    class="d-flex"
    subTitle="Earnings"
    i18n-subTitle="@@common.earnings"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@finance.earnings_table_hint">
      The Earnings section allows you to collect all payments that you owe to the affiliate for generating traffic. Generated Earnings can
      be sent to Invoices, to arrange a payment with an affiliate, or directly to Payments.
    </div>
    <div class="mb-15" i18n="@@finance.earnings_table_hint_data_exporter_button">
      Data Exporter — jump to a thorough statistics report regarding earnings.
    </div>
    <div class="mb-15" i18n="@@finance.earnings_table_hint_create_earning_for_active_affiliates_button">
      Create Earnings for Active Affiliates — generate individual earnings lists for all affiliates that were active during a set period.
      After selecting a timeframe, you get a list of affiliates who have generated some traffic during it and who you can generate earnings
      for.
    </div>
    <div class="mb-15" i18n="@@finance.earnings_table_hint_download_button">
      Download — download an XLS file with earnings. It can include either all earnings or only earnings of those affiliates who have the
      Wire Transfer selected as the default payment method.
    </div>
    <div class="mb-10" i18n="@@finance.earnings_table_hint_filters_application_note">
      Note, that the following filters are simultaneously applied to both the earnings table and the downloadable list of earnings:
    </div>
    <ul class="mb-15">
      <li i18n="@@finance.earnings_table_hint_threshold_per_affiliate_filter_name">Threshold per Affiliate</li>
      <li i18n="@@finance.earnings_table_hint_status_filter_name">Status</li>
      <li i18n="@@finance.earnings_table_hint_earning_from_filter_name">Earning From</li>
      <li i18n="@@finance.earnings_table_hint_earning_to_filter_name">Earning To</li>
    </ul>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.FINANCE_INVOICES"
    class="d-flex"
    subTitle="Invoices"
    i18n-subTitle="@@common.invoices"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@finance.invoices_table_hint">
      An invoice shows how much you are going to pay to an affiliate and collects information needed to complete a payment. To be created,
      an invoice must be linked to an Earnings list.
    </div>
    <div class="mb-15" i18n="@@finance.invoices_table_hint_1">
      The Invoice step is optional, as you can create payments directly from earnings lists.
    </div>
    <div class="mb-15" i18n="@@finance.invoices_table_hint_2">
      Affiliates can create or edit invoices, from their cabinet too. To create invoices, an affiliate must have at least one earning list
      with “Applied“ status. Also, they can only edit invoices with a “Draft” status.
    </div>
    <div class="mb-15" i18n="@@finance.invoices_table_hint_3">
      If an invoice has been created by an affiliate, it will be specified in the “Status Changed By” field.
    </div>
    <div class="mb-15" i18n="@@finance.invoices_table_hint_plus_btn">
      The Plus button — create an invoice by manually filling in all the required fields.
    </div>
    <div class="mb-15" i18n="@@finance.invoices_table_hint_eq_btn">The Equalizer button — apply filters to find specific Earnings.</div>
    <div class="mb-15" i18n="@@finance.invoices_table_hint_gear_btn">
      The Gear button — add and remove columns from the table and change their order.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.FINANCE_PAYMENTS"
    class="d-flex"
    subTitle="Payments"
    i18n-subTitle="@@common.payments"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@finance.payments_table_hint">
      Payments allow you to keep track of the billing process and confirm transactions by attaching documents.
    </div>
    <div class="mb-15" i18n="@@finance.invoices_table_hint_1">Affiliates can’t create or edit payments, but they can view them.</div>
    <div class="mb-15" i18n="@@finance.invoices_table_hint_2">
      Create a Payment right from an Earnings list if you don’t need an Invoice from an affiliate. To do it, go to Earnings, mark a related
      earnings list, and click the Actions button, which appears on top of the screen, then click the Create Payments button.
    </div>
    <div class="mb-15" i18n="@@finance.payments_table_hint_plus_btn">
      The Plus button — create a payment by manually filling in all the required fields.
    </div>
    <div class="mb-15" i18n="@@finance.invoices_table_hint_equalizer_btn">
      The Equalizer button — apply filters to find specific payments in the table.
    </div>
    <div class="mb-15" i18n="@@finance.invoices_table_hint_gear_btn">
      The Gear button — add and remove columns from the table and change their order.
    </div>
  </gtd-help-information>
  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.ACCESS_TO_FREE_PARAMETERS"
    class="d-flex"
    subTitle="Info"
    i18n-subTitle="@@common.info"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@offer.access_to_free_parameters_hint">
      Give affiliates access to Free Parameters of selected Offer URLs. Free Parameters can be configured in Offer>Offer URLs.
    </div>
  </gtd-help-information>
  <gtd-help-information *ngSwitchCase="HintTemplateConstant.ADVERTISER_CONDITIONS" class="d-flex" subTitle="" linkToDocs="">
    <div class="mb-15" i18n="@@offer.advertiser_conditions_hint">
      Customize an Offer URL via Free Parameters. Advertiser’s resource must be integrated.
    </div>
  </gtd-help-information>
  <gtd-help-information *ngSwitchCase="HintTemplateConstant.GOALS" class="d-flex" subTitle="" linkToDocs="">
    <div class="mb-15" i18n="@@offer.goals_hint">
      Goal is one of the aims of a marketing campaign. When a lead makes an action and achieves the Goal, a Conversion occurs.
    </div>
  </gtd-help-information>
  <gtd-help-information *ngSwitchCase="HintTemplateConstant.OFFER_URLS" class="d-flex" subTitle="" linkToDocs="">
    <div class="mb-15" i18n="@@offer.offer_urls_hint">
      URLs — links to advertised pages. Affiliates put them on their resources to attract leads. When a lead visits such a link, a click
      occurs.
    </div>
  </gtd-help-information>
  <gtd-help-information *ngSwitchCase="HintTemplateConstant.AFFILIATE_TRACKING_DOMAINS" class="d-flex" subTitle="" linkToDocs="">
    <div class="mb-15" i18n="@@offer.affiliate_tracking_domains_hint">
      Third-party domains that keep advertised pages safe and track clicks to measure the effectiveness of marketing campaigns.
    </div>
  </gtd-help-information>
  <gtd-help-information *ngSwitchCase="HintTemplateConstant.AFFILIATE_ACCESS" class="d-flex" subTitle="" linkToDocs="">
    <div class="mb-15" i18n="@@offer.affiliate_access_hint">Make the offer visible for some affiliates and hide it from the others.</div>
  </gtd-help-information>
  <gtd-help-information *ngSwitchCase="HintTemplateConstant.AFFILIATE_TRACKERS" class="d-flex" subTitle="" linkToDocs="">
    <div class="mb-15">
      <p class="mb-15" i18n="@@offer.affiliate_trackers_hint_1">
        Affiliate Trackers are postbacks to third-party resources. They are sent each time the affiliate lands a conversion. Usually,
        affiliates use them to track their efficiency.
      </p>
      <p i18n="@@offer.affiliate_trackers_hint_2">They are equal to Default Trackers from Affiliates>Affiliate Trackers.</p>
    </div>
  </gtd-help-information>
  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.TARGETING"
    class="d-flex"
    subTitle="Info"
    i18n-subTitle="@@common.info"
    linkToDocs=""
  >
    <p class="mb-15" i18n="@@offer.targeting_hint">
      Restrict traffic from certain countries. Leads from such countries can’t open advertised pages and their clicks don’t get recorded.
    </p>
    <p i18n="@@offer.targeting_hint_1">Alternatively, you can pair it with Traffic Back URLs to redirect such traffic to other pages.</p>
  </gtd-help-information>
  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.TRAFFIC_BACK_URLS"
    class="d-flex"
    subTitle="Info"
    i18n-subTitle="@@common.info"
    linkToDocs=""
  >
    <p i18n="@@offer.traffic_back_urls_hint">Redirect traffic that was blocked via Targeting Rules.</p>
  </gtd-help-information>
  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.RISK_MANAGEMENT"
    class="d-flex"
    subTitle="Info"
    i18n-subTitle="@@common.info"
    linkToDocs=""
  >
    <p class="mb-15" i18n="@@offer.risk_management_hint">
      Skip conversions in a variety of ways. Affiliates can’t see them. You can also manually approve skipped conversions.
    </p>
    <p class="mb-15" i18n="@@offer.risk_management_hint_1">
      Local CR— select which conversions in a sequence get skipped and enter their ordinal number. For example, you can skip every 2nd, 5th
      or 19th conversion.
    </p>
    <p class="mb-15" i18n="@@offer.risk_management_hint_2">
      Global CR — same as the Local one, but it allows you to configure custom sequences.
    </p>
    <p class="mb-15" i18n="@@offer.risk_management_hint_3">Late CR — set an allowed delay between lead’s click and conversion.</p>
    <p i18n="@@offer.risk_management_hint_4">
      Relative CR — same as the Late one, but it allows you to select a period from a list and adjust it by adding or taking seconds.
    </p>
  </gtd-help-information>
  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.CREATE_QUALIFICATION_ADD_FIELDS"
    class="d-flex"
    subTitle="Info"
    i18n-subTitle="@@common.info"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@offer.create_qualification_add_fields_hint">
      Extra Goal Types allow you to reach the Baseline Amount with conversions of several Goal Types.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.CONVERSION_PROFILE"
    class="d-flex"
    subTitle="Conversion Profile"
    i18n-subTitle="@@common.conversion_profile"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@offer.conversion_profile_hint">
      Add Conversion Profile fields to track custom information about conversions. You can create up to 50 fields. All of them will be added
      to conversion tables across the CRM and will have the full functionality of the platform.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.AFFILIATES_REQUESTS"
    class="d-flex"
    subTitle="Affiliates Requests"
    i18n-subTitle="@@affiliate.requests"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@affiliates.requests_hint">
      Offers with “Request Only” status are not available to affiliates by default. Affiliates must request access to them at first, and
      these requests are recorded in this table.
    </div>
    <div class="mb-15" i18n="@@affiliates.requests_hint_1">
      Approve a request if you want the affiliate to be able to promote the offer.
    </div>
    <div class="mb-10" i18n="@@affiliates.requests_hint_2">Check mark — approve access to this offer.</div>
    <div class="mb-15" i18n="@@affiliates.requests_hint_3">Cross mark — decline access to this offer.</div>

    <div class="mt-10">
      <ng-container i18n="@@affiliates.requests_hint_4">Statuses:</ng-container>
      <ul>
        <li i18n="@@affiliates.requests_hint_5">
          Requested: an affiliate has sent an access request. You can either approve or decline it.
        </li>
        <li i18n="@@affiliates.requests_hint_6">
          Declined: you or another user of the CRM has already declined access to this offer. The affiliate can’t promote this offer.
        </li>
        <li i18n="@@affiliates.requests_hint_7">
          Approved: you or another user of the CRM has already approved access to this offer. The affiliate can promote the offer.
        </li>
      </ul>
    </div>
    <div class="mb-15" i18n="@@affiliates.requests_hint_8">
      Also, you can approve or decline several requests simultaneously: click checkboxes near selected requests, then click the “Actions”
      and select a status.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.OFFER_DESCRIPTION_PRESETS_LIST"
    class="d-flex"
    subTitle="Offer Description Presets"
    i18n-subTitle="@@offer.description_presets"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@offer_description_presets_list_hint">
      Create, edit, and save descriptions that can be quickly added to any offer. To add a description preset to an offer, go to
      <b>Offer</b>><b>Settings</b>><b>Additional</b> and select a preset from a drop-down list in the <b>Description</b> field.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.COMPARING_ANALYTICS"
    class="d-flex"
    subTitle="Comparing Analytics"
    i18n-subTitle="@@common.comparing_analytics"
    linkToDocs=""
  >
    <div i18n="@@offer.comparing_analytics_hint">
      Compare entities like advertisers, affiliates, offers, and countries using custom metrics in two different periods. Save your favorite
      reports via presets to access them quickly.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.AFFILIATE_KYC"
    class="d-flex"
    subTitle="Affiliate KYC"
    i18n-subTitle="@@affiliate.kyc"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@settings.affiliate_kyc_hint">
      Know Your Client module (KYC) controls the document management between you and an affiliate. It allows customizing a document flow,
      sharing files, and approving them.
    </div>
    <div class="mb-15" i18n="@@settings.affiliate_kyc_hint_1">
      Create a KYC schema: it includes as many steps as you wish, in each of them an action might be needed either from you or from an
      affiliate.
    </div>
    <div class="mb-15" i18n="@@settings.affiliate_kyc_hint_2">
      Default — a default schema applies to all Affiliates. There can be only one default schema.
    </div>
    <div class="mb-15" i18n="@@settings.affiliate_kyc_hint_3">
      Archived — put the schema in the archive. You can get a scheme back from the archive and all the files from affiliates will be saved.
    </div>
    <div class="mb-10" i18n="@@settings.affiliate_kyc_hint_4">How to assign a KYC schema to an affiliate?</div>
    <div class="mb-15" i18n="@@settings.affiliate_kyc_hint_5">
      Go to Affiliates and click the Edit icon. In the KYC Schema field, choose the schema that you want to assign to the Affiliate. Click
      Submit.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.AFFILIATE_KYC_ID"
    class="d-flex"
    subTitle="Affiliate KYC"
    i18n-subTitle="@@affiliate.kyc"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@settings.affiliate_kyc_id_hint">
      To configure each step of a schema, click on its ID and then click plus:
    </div>
    <div class="mb-15" i18n="@@settings.affiliate_kyc_id_hint_1">Type — define who has to send a document: an affiliate or a manager.</div>
    <div class="mb-15" i18n="@@settings.affiliate_kyc_id_hint_2">
      Approve — define whether it should be approved automatically or manually by the person who receives the file (an affiliate or a
      manager).
    </div>
    <div class="mb-15" i18n="@@settings.affiliate_kyc_id_hint_3">Description — that’s what a person sees when asked to upload a file.</div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.CRM_QUESTIONS"
    class="d-flex"
    subTitle="CRM Questions"
    i18n-subTitle="@@settings.crm_questions"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@settings.crm_questions_hint">
      Create a questionnaire for affiliates to ensure they fit your requirements.
    </div>
    <div class="mb-15" i18n="@@settings.crm_questions_hint_1">
      Affiliate Questions are shown to an affiliate when he logs in the cabinet. You can review the affiliate's answers in the Affiliate
      page > Other > Questions.
    </div>
    <div class="mb-15" i18n="@@settings.crm_questions_hint_2">
      Offer Questions are shown to an affiliate when he requests access to an offer with a “Request Only” access. You can review answers in
      Affiliates > Affiliate Requests > the “Answers” column.
    </div>
    <div class="mb-15" i18n="@@settings.crm_questions_hint_3">Check results in a separate column in the Affiliate Requests table.</div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.CURRENCY_PROVIDER"
    class="d-flex"
    subTitle="Currency Provider"
    i18n-subTitle="@@currency.provider"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@settings.currency_provider_hint">
      Fill in the API Settings field using credentials from a third-party provider to get currency exchange updates to be able to convert
      currency in invoices.
    </div>
    <div class="mb-15" i18n="@@settings.currency_provider_hint_1">
      The “update_frequency” field shows how often the exchange rate should be updated. Its value defines the length of intervals between
      rate updates in hours.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.PULLING_MAPPINGS"
    class="d-flex"
    subTitle="Pulling Mappings"
    i18n-subTitle="@@settings.pulling_mappings"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@settings.pulling_mappings_hint">
      This feature describes how to map pulled conversions with a specific attribute from the advertiser’s source and record them in the
      CRM. It copies only conversions with the selected Type. When conversions are recorded in the CRM, their Type attribute is replaced
      with a selected Goal Type.
    </div>
    <div class="mb-15" i18n="@@settings.pulling_mappings_hint_1">Advertiser – Conversions will be attached to this Advertiser.</div>
    <div class="mb-15" i18n="@@settings.pulling_mappings_hint_2">
      Type – the parameter of conversion, which is recorded in the advertiser’s source.
    </div>
    <div class="mb-15" i18n="@@settings.pulling_mappings_hint_3">
      Goal Type – The Goal that would be recorded for all conversions with selected Type.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.REFERRAL_BUSINESS_MODELS"
    class="d-flex"
    subTitle="Referral Business Models"
    i18n-subTitle="@@settings.referral_business_models"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@settings.referral_business_models_hint">
      With a Referral business model, you can determine a formula for a referral reward. The referral reward means how much a referrer gets
      for each successful action of a referred affiliate.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.REFERRAL_PROGRAMS"
    class="d-flex"
    subTitle="Referral Programs"
    i18n-subTitle="@@settings.referral_programs"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@settings.referral_programs_hint">
      Create, edit, and review Referral Programs. The list of fields that are crucial for configuring a Referral Program:
    </div>
    <div class="mb-15" i18n="@@settings.referral_programs_hint_1">Program type: select how to pay for the referral reward:</div>
    <div class="mb-15" i18n="@@settings.referral_programs_hint_2">
      Referral Bonus—the CRM owners provide from their budget both the referral reward to the referrer and the full payout to the referred
      user.
    </div>
    <div class="mb-15" i18n="@@settings.referral_programs_hint_3">
      Referral Correction—the CRM owners provide only the payout to the referred user. The referral reward is deducted from that payout.
    </div>
    <div class="mb-15" i18n="@@settings.referral_programs_hint_4">
      Referral Business Model: select a formula that determines the payout of the referrer.
    </div>
    <div class="mb-15" i18n="@@settings.referral_programs_hint_5">
      Referral Payout: if you want to set a constant number in the formula, add the number in this field and make sure there is the
      {{ '{' }}payout{{ '}' }} placeholder in the Referral Business Model. The number from that field substitutes the placeholder in the
      formula.
    </div>
    <div class="mb-15" i18n="@@settings.referral_programs_hint_6">Conditions: configure in which cases a referral reward is added.</div>
    <div class="mb-15" i18n="@@settings.referral_programs_hint_7">
      Country: select specific geolocations to which the referral program is applied.
    </div>
    <div class="mb-15" i18n="@@settings.referral_programs_hint_8">
      Goal types: conversions with the selected goal types lead to referral rewards.
    </div>
    <div class="mb-15" i18n="@@settings.referral_programs_hint_9">
      Transaction type: selected transaction types, besides conversion, can also lead to referral rewards.
    </div>
    <div class="mb-15" i18n="@@settings.referral_programs_hint_10">
      Privacy: Select if you want to make this program available for all affiliates, or hide it.
    </div>
  </gtd-help-information>

  <gtd-help-information
    *ngSwitchCase="HintTemplateConstant.AFFILIATE_INVOICE_CONSOLIDATION"
    class="d-flex"
    subTitle="Affiliate Consolidation"
    i18n-subTitle="@@affiliate.consolidation"
    linkToDocs=""
  >
    <div class="mb-15" i18n="@@settings.affiliate_invoice_consolidation_hint">
      If a user or an organization has several affiliate accounts with the same payment method, you can combine invoices for all these
      accounts. A consolidated invoice contains billing information for all these accounts, and it’s visible to all included accounts.
      Affiliate Consolidation applies to Earnings, Invoices, and Payments.
    </div>
  </gtd-help-information>
</ng-container>
